module.exports = __webpack_public_path__ + "static/result-dummy-a1503299174b59fc842836348dbabfe0.jpeg";